import React, { useState } from 'react'
import { assets } from '../assets/assets'
import { Link, useLocation} from 'react-router-dom'



const Navbar = () => {

  return (
    <div className='flex flex-row items-center sticky top-0 w-full overflow-x-hidden bg-blue-500 py-2 justify-between z-50'>  
        <div className='flex flex-row items-center'>
          <div className='ml-4'>
            <Link to='/'>
              <img className='w-24 height-auto flex items-left' src={assets.blue} alt='StreamWest'/>
            </Link>
          </div>

          <div className='flex items-center justify-center gap-4 sm:gap-8 text-xs sm:text-sm md:text-base lg:text-base whitespace-nowrap overflow-hidden'>
            <Link to='/'className='text-white hover:text-gray-400 ml-8'>Home</Link>
            <Link to='/videos'className='text-white hover:text-gray-400 '>Videos</Link>
            <Link to='/upload'className='text-white hover:text-gray-400 '>Upload</Link>
            <Link to='/about'className='text-white hover:text-gray-400 '>About</Link>
          </div>
        
        </div>
         <div className='flex justify-right mr-4 mt-2'>
            <a href="https://wamoody.com"
              className="" 
              target="_blank"
              rel="noopener noreferrer">
            <img className='w-12 height-auto animate-sine' src = {assets.wmlogo} alt ='wm'/>
            </a>
          </div> 
      </div>

  )
}

export default Navbar
